import axios from 'axios'
import { stringToByte, byteToString } from './stringBytes'
import uuidv1 from 'uuid/dist/v1'
import CryptoJS from 'crypto-js'
import base64 from 'base64-url'
import {getCookie} from './getCookie'

// import zoroReport from '../zoro/zoro_sdk.js';

// import Toast from 'dudys/lib/Library/Toast/Toast'

/**
 * 生成HTTP请求函数
 * @param {String} url 后端服务地址
 * @param {Object} params 参数
 * @param {String} projectName 项目名称 用于错误上报
 */



const http_zcm = async ({ url, params = {}, projectName }) => {
    let uid = '';
    let ppuStr = getCookie('PPU');
    let _reg = /UID=\d*(?=&)/gm;
    let uidArr = ppuStr.match(_reg) ? ppuStr.match(_reg) : [];
    let uidstr = uidArr.length ? uidArr[0] : '=';
    uid = uidstr.split('=')[1]
    const zpVersion = getCookie("zp-version") || '0.0.0';
    let config = {
        contentType: 'form',
        headers: {
            "zp-version": zpVersion,
            "Content-Type": "application/x-www-form-urlencoded"
        }
    };
    config.withCredentials = true;
    const uuid = uuidv1().replace(/\-/g, "");
    const keyArr = stringToByte("2" + uuid);
    // aes加密的password
    let password = keyArr.map((item, index) => {
        if (index % 3 == 2) {
            return item ^ 2
        }
        return item;
    });
    password = byteToString(password);
    password = base64.encode(password);
    password = password.slice(0, 16);
    // 需要加密的字段
    params = {...params,uid:uid}
    const { cmd, ...others } = params;
    let hbody = Object.keys(others).length == 0 ? JSON.stringify({ uuid }) : JSON.stringify(others);
    hbody = CryptoJS.AES.encrypt(hbody, CryptoJS.enc.Utf8.parse(password), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString();
    const sign = CryptoJS.MD5(`${params.cmd}&hbody=${hbody}&uuid=${uuid}&index=h5&h5`).toString();
    // 代码 “不” 多余
    // 两次encode
    hbody = encodeURIComponent(hbody);
    hbody = encodeURIComponent(hbody);
    const requestBody = {
        hbody,
        uuid,
        sign,
        cmd,
        key: "h5",
        index: "h5",
        uid: uid
    }
    // requestBody.uid = uid;
    let formData = "";
    for (let key in requestBody) {
        formData += `${key}=${requestBody[key]}&`;
    }
    config = { ...config, data: formData, method: 'post', url };
    let errorResult = undefined;
    try {
        const res = await axios(config);
        errorResult = { ...res }
        //  解密过程
        let { result, resultcode } = res.data;
        result = CryptoJS.AES.decrypt(result, CryptoJS.enc.Utf8.parse(password), { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8);
        // console.log(result, '-------')

        if (parseInt(resultcode) === 0) {
            if (typeof result == "string") {
                res.data.result = JSON.parse(result);
            }
        } else {
            console.group("返回值异常:");
            console.log(res.data);
            console.log("uuid:" + uuid);
            console.log("反解请去：http://zoro.58corp.com/zoro/client/index");
            console.groupEnd();
        }
        //返回result 少一层解析

        //http_zcm不该对业务状态码进行判断，应该返回完整的接口放回数据。
        //至于接口是否正常应由下游 LoadingContainer进行处理
        return res.data;
    }
    catch (error) {
        return console.log("出错啦~",error);
        // 错误上报的功能
        // if (Toast) {
        //     Toast.show("请检查您的网络~");
        // }
        // const zoro_sdk = zoroReport({ project: projectName || 'activity' });
        // console.error(error, "http_zcm");
        // const sendError = { error, result: errorResult };
        // zoro_sdk.sendCustomError("http_zcm", sendError);
    }
}

export default http_zcm;
